"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleFocus = handleFocus;
exports.handleBlur = handleBlur;
exports.default = FocusMixin;
const widget_helpers_1 = require("./widget-helpers");
const compat_1 = require("./compat");
function _handleFocus(inst, focused, event, didHandle, willHandle) {
    const handler = inst.props[focused ? 'onFocus' : 'onBlur'];
    if (handler && event) {
        event.persist();
    }
    if (willHandle && willHandle.call(inst, focused, event) === false) {
        return;
    }
    inst.setTimeout('focus', () => {
        (0, compat_1.batchedUpdates)(() => {
            var _a;
            if (didHandle) {
                didHandle.call(inst, focused, event);
            }
            if (focused !== inst.focused) {
                (0, widget_helpers_1.notify)(handler, event);
                if (inst.isMounted) {
                    (_a = inst.setFocused) === null || _a === void 0 ? void 0 : _a.call(inst, focused);
                }
            }
        });
    });
}
function handleFocus(inst, event, didHandle, willHandle) {
    _handleFocus(inst, true, event, didHandle, willHandle);
}
function handleBlur(inst, event, didHandle, willHandle) {
    _handleFocus(inst, false, event, didHandle, willHandle);
}
function FocusMixin({ willHandle, didHandle }) {
    return {
        handleBlur(event) {
            _handleFocus(this, false, event, didHandle, willHandle);
        },
        handleFocus(event) {
            _handleFocus(this, true, event, didHandle, willHandle);
        }
    };
}
//# sourceMappingURL=focus-mixin.js.map